function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define("YWWriterIconsReact.Check", ["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React);
    global.YWWriterIconsReact = global.YWWriterIconsReact || {};
    global.YWWriterIconsReact["Check"] = mod.exports.default;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (exports, React) {
  "use strict";

  var Check = props => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.6515 6.15152C20.1829 5.68289 19.4231 5.68289 18.9544 6.15152L9.50001 15.6059L5.54561 11.6515C5.07697 11.1829 4.31717 11.1829 3.84853 11.6515C3.3799 12.1201 3.3799 12.8799 3.84853 13.3486L9.49999 19.0001L20.6515 7.84858C21.1201 7.37995 21.1201 6.62015 20.6515 6.15152Z",
    fill: "currentColor"
  }));
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = Check;
});